import type { ReactNode } from "react";

import logo from "../assets/ownerflow_logo.png";
import { cn } from "../lib/cn";

/** Header / lockup mark. Slightly smaller than the old 36px so it matches the wordmark. */
export const OWNERFLOW_MARK_SIZE = 28;

interface OwnerFlowLogoProps {
  size?: number;
  className?: string;
}

export function OwnerFlowLogo({ size = OWNERFLOW_MARK_SIZE, className }: OwnerFlowLogoProps) {
  return (
    <img
      src={logo}
      alt="OwnerFlow"
      className={cn("block flex-none object-contain", className)}
      style={{ height: size, width: size }}
    />
  );
}

interface OwnerFlowBrandProps {
  markSize?: number;
  className?: string;
  markClassName?: string;
  wordmarkClassName?: string;
  wordmark?: ReactNode;
  hideWordmarkClassName?: string;
}

export function OwnerFlowBrand({
  markSize = OWNERFLOW_MARK_SIZE,
  className,
  markClassName,
  wordmarkClassName,
  wordmark = "OwnerFlow",
  hideWordmarkClassName,
}: OwnerFlowBrandProps) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <OwnerFlowLogo size={markSize} className={cn("translate-y-px", markClassName)} />
      <span
        className={cn(
          "text-[17px] font-bold leading-none tracking-tight",
          hideWordmarkClassName,
          wordmarkClassName,
        )}
      >
        {wordmark}
      </span>
    </span>
  );
}
